import r from "@mapbox/mapbox-gl-draw";
import { PL_DIRECT_SELECT as s, PL_DEFAULT_SELECT as l } from "./index.es445.js";
const i = r.constants, t = r.lib, u = r.modes.draw_polygon, n = { ...u };
n.clickAnywhere = function(o, e) {
  if (o.currentVertexPosition > 0 && t.isEventAtCoordinates(e, o.polygon.coordinates[0][o.currentVertexPosition - 1]))
    return this.changeMode(s, { featureId: o.polygon.id });
  this.updateUIClasses({ mouse: i.cursors.ADD }), o.polygon.updateCoordinate(`0.${o.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat), o.currentVertexPosition++, o.polygon.updateCoordinate(`0.${o.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
};
n.clickOnVertex = function(o) {
  return this.changeMode(s, { featureId: o.polygon.id });
};
n.onKeyUp = function(o, e) {
  t.CommonSelectors.isEscapeKey(e) ? (this.deleteFeature([o.polygon.id], { silent: !0 }), this.changeMode(l)) : t.CommonSelectors.isEnterKey(e) && this.changeMode(s, { featureId: o.polygon.id });
};
n.onStop = function(o) {
  this.updateUIClasses({ mouse: i.cursors.NONE }), t.doubleClickZoom.enable(this), this.activateUIButton(), this.getFeature(o.polygon.id) !== void 0 && (o.polygon.removeCoordinate(`0.${o.currentVertexPosition}`), o.polygon.isValid() ? this.map.fire(i.events.CREATE, {
    features: [o.polygon.toGeoJSON()]
  }) : (this.deleteFeature([o.polygon.id], { silent: !0 }), this.changeMode(l, {}, { silent: !0 })));
};
n.onTrash = function(o) {
  this.deleteFeature([o.polygon.id], { silent: !0 }), this.changeMode(l);
};
export {
  n as default
};
//# sourceMappingURL=index.es380.js.map
